import React from "react";
import { Badge, Row } from "react-bootstrap";
import { components } from "react-select";
import { isNullOrUndefined } from "util";
import {
  downloadSpreadsheet,
  downloadSpreadsheetWithTagLevels,
} from "../../../../../docuclipper/api";
import {
  ExportType,
  Job,
  TableFilterConfig,
} from "../../../../../docuclipper/DocuclipperTypes";
import store from "../../../../../redux";
import { createAlert } from "../../../../../redux/reducers/Alerts";
import { fetchAnnouncement } from "../../../../../redux/reducers/Announcement";
import { setHelpDrawerOpen } from "../../../../../redux/reducers/HelpDrawer";
import {
  setDownloadModalOpen,
  setExportType,
} from "../../../../../redux/reducers/JobExport";
import { openModal } from "../../../../../redux/reducers/ModalManager";
import {
  ReconciledNo,
  ReconciledUnknown,
  ReconciledYes,
} from "../../ReconciledBadge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { saveAs } from "file-saver";
import { sendGAEvent } from "../../../../../utils/utils";

export function downloadSpreadsheetHelper(
  job: Job | null,
  l1,
  l2,
  jobType: Job["jobType"],
  format: ExportType,
  params: { [k: string]: any },
  selectedDocumentIds: string[],
  selectedFieldNames: string[],
  filteredTlIds: string[],
  filters: TableFilterConfig[],
  sortBy: string,
  sortDirection: string,
  fileType?: "CSV" | "XLSX",
  preview?: boolean,
  selectedExportFields?: any
) {
  if (!format) {
    return null as any;
  }
  let extension = format;
  if (
    [
      "xero-csv",
      "sage-csv",
      "sage-cloud-csv",
      "myob",
      "relate",
      "netsuite",
    ].includes(format)
  ) {
    extension = "csv";
  }
  if (["qif"].includes(format)) {
    extension = "qif";
  } else if (["ofx"].includes(format)) {
    extension = "ofx";
  } else if (["xlsx"].includes(format)) {
    extension = "xlsx";
  } else if (fileType?.toLowerCase() === "csv") {
    extension = "csv";
  } else if (fileType?.toLowerCase() === "xlsx") {
    extension = "xlsx";
  }
  const downloadPromise =
    l1 && l2
      ? downloadSpreadsheetWithTagLevels(
          l1,
          l2,
          jobType,
          format,
          true,
          selectedDocumentIds || [],
          params,
          selectedFieldNames,
          filteredTlIds,
          filters,
          sortBy,
          sortDirection,
          fileType,
          preview,
          selectedExportFields
        )
      : job && job.id
      ? downloadSpreadsheet(
          job.id,
          jobType,
          format,
          true,
          selectedDocumentIds || [],
          params,
          selectedFieldNames,
          filteredTlIds,
          filters,
          sortBy,
          sortDirection,
          fileType,
          preview,
          selectedExportFields
        )
      : Promise.reject();

  if (!preview) {
    sendGAEvent({
      action: "export_attempted",
      category: "Funnel",
      label: format,
    });
  }

  return downloadPromise
    .then((data) => {
      if (preview) return data;
      sendGAEvent({
        action: "export_succeeded",
        category: "Funnel",
        label: format,
      });

      // store.dispatch(setExportType(format as any));
      store.dispatch(setDownloadModalOpen(false));
      // if (localStorage.getItem("docuclipper.helpDrawer.dontShow") !== "true") {
      //   store.dispatch(setHelpDrawerOpen(true));
      // }

      if (data.type === "application/zip") {
        extension += ".zip";
      }
      let filename;
      if (job) {
        filename = `${
          job.name || (job.template ? job.template.name || "" : "")
        }-docuclipper.${extension}`;
      } else {
        filename = `${l1}-${l2}-docuclipper.${extension}`;
      }
      saveAs(data, filename);
      store.dispatch(
        createAlert({
          message: "Data exported correctly. Check your Downloads folder.",
          timeout: 0,
          type: "success",
        })
      );
      // store.dispatch(fetchAnnouncement());
    })
    .catch((err) => {
      if (!preview) {
        sendGAEvent({
          action: "export_failed",
          category: "Funnel",
          label: format,
        });
      }
      store.dispatch(
        createAlert({
          message: err?.message || "Error downloading file. Please try again.",
          timeout: 0,
          type: "error",
        })
      );
      if (!preview) {
        // don't close modal when preview fails
        store.dispatch(setDownloadModalOpen(false));
      }
      // if (localStorage.getItem("docuclipper.helpDrawer.dontShow") !== "true") {
      //   store.dispatch(setHelpDrawerOpen(true));
      // }

      // if (err.errorCode === 1055) {
      //   store.dispatch(openModal("noData", {}));
      //   // setNoDataHelpTemplateType(
      //   //   err.data ? err.data.templateType || "public" : "public"
      //   // );
      // }
    });
}

const { Option } = components;

export const CheckboxOption = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label className="ml-1">{props.label}</label>
      </components.Option>
    </div>
  );
};

export const CheckboxReconciledOption = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
        {props.data.totals && (
          <>
            <div className="my-1 text-success">
              <span>{`${props.data.totals.numCredits} credits`}</span>

              {` (${props.data.totals.totalCredits})`}
            </div>
            <div className="my-1 text-danger">
              <span>{`${props.data.totals.numPayments} debits`}</span>

              {` (${props.data.totals.totalPayments})`}
            </div>
          </>
        )}
        <div className="m-2">
          {props.data.totals && props.data.totals.isReconciled === true && (
            <ReconciledYes
              type={props.data.reconciledType}
              disableOverlay={true}
            />
          )}
          {props.data.totals && props.data.totals.isReconciled === false && (
            <ReconciledNo
              type={props.data.reconciledType}
              disableOverlay={true}
            />
          )}
          {(isNullOrUndefined(props.data.totals) ||
            isNullOrUndefined(props.data.totals.isReconciled)) && (
            <ReconciledUnknown
              type={props.data.reconciledType}
              disableOverlay={true}
            />
          )}
        </div>
        {/* </Row> */}
      </components.Option>
    </div>
  );
};

export const ReconciledMultiValueLabel = (props) => {
  return (
    <div>
      <components.MultiValueLabel {...props}>
        <span className="">
          <strong>{props.data.label}</strong>
        </span>
        {props.data.totals && (
          <>
            <span className="mx-2 text-success">
              <span>{`${props.data.totals.numCredits} credits`}</span>

              {` (${props.data.totals.totalCredits})`}
            </span>
            <span className="mx-2 text-danger">
              <span>{`${props.data.totals.numPayments} debits`}</span>

              {` (${props.data.totals.totalPayments})`}
            </span>
          </>
        )}
        <span className="mx-2">
          {props.data.totals && props.data.totals.isReconciled === true && (
            <ReconciledYes
              type={props.data.reconciledType}
              disableOverlay={true}
            />
          )}
          {props.data.totals && props.data.totals.isReconciled === false && (
            <ReconciledNo
              type={props.data.reconciledType}
              disableOverlay={true}
            />
          )}
          {(isNullOrUndefined(props.data.totals) ||
            isNullOrUndefined(props.data.totals.isReconciled)) && (
            <ReconciledUnknown
              type={props.data.reconciledType}
              disableOverlay={true}
            />
          )}
        </span>
        {/* </Row> */}
      </components.MultiValueLabel>
    </div>
  );
};

export const IconOption = (props) => (
  <Option {...props}>
    {props.data.icon && (
      <img
        src={props.data.icon}
        style={{ height: props.data.iconHeight || "24px" }}
        alt={props.data.label}
      />
    )}
    <span className={props.data.icon && "ml-2"}>{props.data.label}</span>
    {props.data?.onEdit && (
      <FontAwesomeIcon
        onClick={props.data.onEdit}
        className="ml-2 icon-hover"
        icon="edit"
        style={{ color: "grey", cursor: "pointer" }}
        onMouseOver={(e) => (e.currentTarget.style.color = "blue")}
        onMouseOut={(e) => (e.currentTarget.style.color = "grey")}
      />
    )}
    {props.data?.onDelete && (
      <FontAwesomeIcon
        onClick={props.data.onDelete}
        className="ml-2 icon-hover"
        icon="trash"
        style={{ color: "grey", cursor: "pointer" }}
        onMouseOver={(e) => (e.currentTarget.style.color = "red")}
        onMouseOut={(e) => (e.currentTarget.style.color = "grey")}
      />
    )}
  </Option>
);

const NoTransactionsBadge = () => (
  <Badge variant="secondary" className="p-1 pr-2 text-white">
    <span className="ml-1">No transactions</span>
  </Badge>
);

const PartialExtractionBadge = () => (
  <Badge variant="warning" className="p-1 pr-2 text-white">
    <span className="ml-1">Review fields</span>
  </Badge>
);

const NewBadge = () => (
  <Badge variant="success" className="p-1 pr-2 text-white mr-2">
    <span className="ml-1">NEW</span>
  </Badge>
);

const BadDateBadge = () => (
  <Badge
    variant="warning"
    className="p-1 px-2 text-white mr-2 d-inline-flex align-items-center"
  >
    <FontAwesomeIcon color="white" icon="times" />
    <span className="ml-1">Bad date</span>
  </Badge>
);

const DocumentStateIndicator = ({ data }) => {
  if (data.hasNoTransactions === true) return <NoTransactionsBadge />;
  if (data.hasPartialExtraction === true) return <PartialExtractionBadge />;
  if (data.reconciled === true)
    return <ReconciledYes type={data.reconciledType} disableOverlay={true} />;
  if (data.reconciled === false)
    return <ReconciledNo type={data.reconciledType} disableOverlay={true} />;
  return <ReconciledUnknown type={data.reconciledType} disableOverlay={true} />;
};

export const ReconciledOption = (props) => (
  <Option {...props}>
    <Row className="justify-content-between px-2">
      <span className="ml-2" title={props.data.label}>
        {props.data.label}
      </span>
      <span className="d-flex align-items-center">
        {props.data.isNew && <NewBadge />}
        <DocumentStateIndicator data={props.data} />
      </span>
    </Row>
  </Option>
);

export const ReconciledValue = ({
  cx,
  getStyles,
  selectProps,
  data,
  isDisabled,
}) => {
  return (
    // Mirror react-select's default SingleValue: absolutely positioned so this
    // value adds to neither the control's width nor its height. As an in-flow
    // element it grew the control past its column (overlapping the next
    // selector) and stacked above react-select's hidden input, leaving tall
    // boxes with empty space below. maxWidth + overflow clip it to the control.
    <div
      className="d-flex align-items-center"
      style={{
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        maxWidth: "calc(100% - 8px)",
        overflow: "hidden",
      }}
    >
      <span className="text-truncate mr-1" title={selectProps.getOptionLabel(data)}>
        {selectProps.getOptionLabel(data)}
      </span>
      <span className="flex-shrink-0 d-flex align-items-center">
        {data.isNew && <NewBadge />}
        {data.isBadDate && <BadDateBadge />}
        <DocumentStateIndicator data={data} />
      </span>
    </div>
  );
};

export const IconValue = ({ cx, getStyles, selectProps, data, isDisabled }) => {
  return (
    <div>
      {data.icon && (
        <img
          src={data.icon}
          style={{ height: data.iconHeight || "24px" }}
          alt={data.label}
        />
      )}
      <span className="ml-2">{selectProps.getOptionLabel(data)}</span>
    </div>
  );
};
